import React, { Component } from "react";
import { Link } from "react-router-dom";
import Table from "../common/table/table";

class MatchesTable extends Component {
  columns = [
    {
      key: "edit",
      className: "col-1",
      content: match => (
        <Link to={`/matches/${match.id}`} className="btn btn-info btn-sm">
          <i className="fa fa-edit" />
        </Link>
      )
    },
    {
      key: "delete",
      className: "col-1",
      content: match => (
        <button
          onClick={() => this.props.onDelete(match)}
          className="btn btn-danger btn-sm"
        >
          <i className="fa fa-trash" />
        </button>
      )
    },
    // {
    //   key: "league",
    //   label: "League",
    //   className: "col-2",
    //   content: match => <span>{match.league.name}</span>
    // },
    // {
    //   key: "dateTime",
    //   label: "Date/Time",
    //   className: "col-2"
    // },
    {
      key: "teamHome",
      label: "Home",
      className: "col-4",
      content: match => <span>{match.teamHome.name}</span>
    },
    {
      key: "teamAway",
      label: "Away",
      className: "col-4",
      content: match => <span>{match.teamAway.name}</span>
    },
    {
      key: "score",
      label: "Score",
      className: "col-2",
      content: match =>
        match.isFinished ? (
          <span>{match.scoreHome + " - " + match.scoreAway}</span>
        ) : (
          ""
        )
    }
  ];

  render() {
    const { matches, onSort, sortColumn } = this.props;

    return (
      <div className="container">
        <Table
          columns={this.columns}
          sortColumn={sortColumn}
          onSort={onSort}
          data={matches}
        />
      </div>
    );
  }
}

export default MatchesTable;



// WEBPACK FOOTER //
// ./src/components/matches/matchesTable.jsx